export default {
  ADD_ITEM(state, item) {
    debugger;
    state.OwnersManagements.unshift(item);
  },
  SET_OwnersManagements(state, OwnersManagements) {
    state.OwnersManagements = OwnersManagements;
  },
  UPDATE_OwnersManagement(state, OwnersManagement) {
    const OwnersManagementIndex = state.OwnersManagements.findIndex(p => p.ID == OwnersManagement.ID);
    if (OwnersManagementIndex != -1) {
      Object.assign(state.OwnersManagements[OwnersManagementIndex], OwnersManagement);
    }
  },
  REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.OwnersManagements.findIndex(p => p.ID == itemId);
    state.OwnersManagements.splice(ItemIndex, 1);
  }
};
